import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './Layout';
import { InicioPage } from './InicioPage';

/** Cada pantalla se carga cuando se entra a ella (code splitting por ruta). */
const pagina = <T extends string>(
  cargar: () => Promise<Record<T, React.ComponentType>>,
  nombre: T,
) => lazy(() => cargar().then((modulo) => ({ default: modulo[nombre] })));

const LoginPage = pagina(() => import('@/features/auth/views/LoginPage'), 'LoginPage');
const CambiarClavePage = pagina(
  () => import('@/features/auth/views/CambiarClavePage'),
  'CambiarClavePage',
);

const PersonasPage = pagina(() => import('@/features/personas/views/PersonasPage'), 'PersonasPage');
const PersonaPage = pagina(() => import('@/features/personas/views/PersonaPage'), 'PersonaPage');

const RomaneosPage = pagina(() => import('@/features/romaneos/views/RomaneosPage'), 'RomaneosPage');
const RomaneoNuevoPage = pagina(
  () => import('@/features/romaneos/views/RomaneoNuevoPage'),
  'RomaneoNuevoPage',
);
const ContratosPage = pagina(
  () => import('@/features/contratos/views/ContratosPage'),
  'ContratosPage',
);
const MermasPage = pagina(() => import('@/features/romaneos/views/MermasPage'), 'MermasPage');
const TarifasYCampaniasPage = pagina(
  () => import('@/features/romaneos/views/TarifasYCampaniasPage'),
  'TarifasYCampaniasPage',
);

const ComprobantesPage = pagina(
  () => import('@/features/comprobantes/views/ComprobantesPage'),
  'ComprobantesPage',
);
const EmitirPage = pagina(() => import('@/features/comprobantes/views/EmitirPage'), 'EmitirPage');

const CobrosPagosPage = pagina(
  () => import('@/features/cobros-pagos/views/CobrosPagosPage'),
  'CobrosPagosPage',
);
const CruzarPage = pagina(() => import('@/features/cobros-pagos/views/CruzarPage'), 'CruzarPage');
const MediosYCajasPage = pagina(
  () => import('@/features/cobros-pagos/views/MediosYCajasPage'),
  'MediosYCajasPage',
);
const LiquidacionesEmpleadosPage = pagina(
  () => import('@/features/administracion/views/LiquidacionesEmpleadosPage'),
  'LiquidacionesEmpleadosPage',
);

const TransportePage = pagina(
  () => import('@/features/transporte/views/TransportePage'),
  'TransportePage',
);
const FlotaPage = pagina(() => import('@/features/flota/views/FlotaPage'), 'FlotaPage');

const StockPage = pagina(() => import('@/features/stock/views/StockPage'), 'StockPage');
const ProductosPage = pagina(() => import('@/features/stock/views/ProductosPage'), 'ProductosPage');

const SaldosPage = pagina(() => import('@/features/informes/views/SaldosPage'), 'SaldosPage');
const VentasComprasPage = pagina(
  () => import('@/features/informes/views/VentasComprasPage'),
  'VentasComprasPage',
);

const CatalogosPage = pagina(
  () => import('@/features/sistema/views/CatalogosPage'),
  'CatalogosPage',
);
const UsuariosPage = pagina(() => import('@/features/sistema/views/UsuariosPage'), 'UsuariosPage');
const AuditoriaPage = pagina(
  () => import('@/features/sistema/views/AuditoriaPage'),
  'AuditoriaPage',
);

const ChequesPage = pagina(
  () => import('@/features/cobros-pagos/views/ChequesPage'),
  'ChequesPage',
);

export function Rutas() {
  return (
    <Suspense fallback={<p className="p-6 text-slate-500">Cargando…</p>}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route element={<Layout />}>
          <Route index element={<InicioPage />} />
          <Route path="/cambiar-clave" element={<CambiarClavePage />} />

          <Route path="/personas" element={<PersonasPage />} />
          <Route path="/personas/:id" element={<PersonaPage />} />

          <Route path="/acopio/romaneos" element={<RomaneosPage />} />
          <Route path="/acopio/romaneos/nuevo" element={<RomaneoNuevoPage />} />
          <Route path="/acopio/contratos" element={<ContratosPage />} />

          <Route path="/comprobantes" element={<ComprobantesPage />} />
          <Route path="/comprobantes/emitir" element={<EmitirPage />} />

          <Route path="/cobros-y-pagos" element={<CobrosPagosPage />} />
          <Route path="/cuentas/cheques" element={<ChequesPage />} />
          <Route path="/cuentas/cruzar" element={<CruzarPage />} />
          <Route
            path="/administracion/liquidaciones-empleados"
            element={<LiquidacionesEmpleadosPage />}
          />

          <Route path="/transporte" element={<TransportePage />} />
          <Route path="/transporte/flota" element={<FlotaPage />} />

          <Route path="/stock" element={<StockPage />} />
          <Route path="/stock/productos" element={<ProductosPage />} />

          <Route path="/informes/saldos" element={<SaldosPage />} />
          <Route path="/informes/ventas-compras" element={<VentasComprasPage />} />

          <Route path="/sistema/usuarios" element={<UsuariosPage />} />
          <Route path="/sistema/catalogos" element={<CatalogosPage />} />
          <Route path="/sistema/mermas" element={<MermasPage />} />
          <Route path="/sistema/tarifas" element={<TarifasYCampaniasPage />} />
          <Route path="/sistema/medios" element={<MediosYCajasPage />} />
          <Route path="/sistema/auditoria" element={<AuditoriaPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
